// import React, { useEffect, useState } from "react";
// import Map from "./Map";
// import { Row, Col, Card, Form, Button, CardBody } from "react-bootstrap";
// import Select from "react-select";
// import {
//   getAllStates,
//   getAllCities,
//   clearMessages,
//   getRoles,
// } from "../../redux/slices/profileSlice";

// import MapViewIcon from "../../assets/images/map-view-icon.png";
// import ListViewIcon from "../../assets/images/list-view.png";
// import { useDispatch, useSelector } from "react-redux";
// import { getHospitalData } from "../../redux/slices/comparison.Slice";
// import HospitalListing from "../hospitalListing";
// import NoIndexSEO from "../SEO/NoIndexSEO";
// import { seoConfig } from "../../utils/seoConfig";

// const FullMapPage = () => {
//   const [mapData, setMapData] = useState({
//     selectedRole: "",
//     city: "",
//     state: "",
//     hospitalData: [],
//   });
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedCity, setSelectedCity] = useState("");
//   const [stateOptions, setStateOptions] = useState([]);
//   const [cityOptions, setCityOptions] = useState([]);
//   const [view, setView] = useState("map");
//   const [selectedHospitalRole, setSelectedHospitalRole] = useState(null);
//   const [filterRoleOptions, setFilterRoleOptions] = useState([]);
//   const store = useSelector((state) => state.profile);
//   const comparisonStore = useSelector((state) => state.comparison);
//   console.log(comparisonStore, "Store Data");
//   console.log(filterRoleOptions, "filterRoleOptions");
//   console.log(selectedHospitalRole, "selectedHospitalRole");
//   const dispatch = useDispatch();

//   // // Load map data from localStorage when the page opens
//   // useEffect(() => {}, []);

//   useEffect(() => {
//     dispatch(getAllStates());
//     dispatch(getRoles());
//   }, []);

//   useEffect(() => {
//     if (selectedState) {
//       dispatch(
//         getAllCities({
//           search_state: selectedState ? selectedState?.value : selectedState,
//         })
//       );
//     }
//   }, [dispatch, selectedState]);

//   // useEffect(() => {
//   //   if (store?.successMessage && store?.actionFlag && store?.errorMessage) {
//   //     clearMessages();
//   //   }
//   //   if (store?.actionFlag === "ROLE_SCS") {
//   //     if (store?.roleItems?.data) {
//   //       const data = store?.roleItems?.data?.describe_roles?.map((s) => ({
//   //         value: s.id,
//   //         label: s.name,
//   //       }));
//   //       setFilterRoleOptions(data);
//   //     }
//   //   }

//   //   if (store?.actionFlag === "STATES_SCS") {
//   //     if (store?.stateItems?.data?.states) {
//   //       const stateOptions = store?.stateItems?.data?.states?.map((s) => ({
//   //         value: s.state,
//   //         label: s.state_full_name,
//   //       }));
//   //       setStateOptions(stateOptions);
//   //     }
//   //   }

//   //   if (store?.actionFlag === "CITIES_SCS" && store?.cityItems?.data) {
//   //     const data = store?.cityItems?.data?.cities?.map((c) => ({
//   //       value: c.city,
//   //       label: c.city,
//   //     }));
//   //     setCityOptions(data);
//   //   }
//   // }, [
//   //   // selectedState,
//   //   store?.actionFlag,
//   //   // store?.cityItems?.data,
//   //   // store?.errorMessage,
//   //   // store?.stateItems?.data?.states,
//   //   // store?.successMessage,
//   // ]);

//   useEffect(() => {
//     if (store?.actionFlag === "ROLE_SCS") {
//       const data = store?.roleItems?.data?.describe_roles?.map((s) => ({
//         value: s.id,
//         label: s.name,
//       }));
//       setFilterRoleOptions(data);
//     }

//     if (store?.actionFlag === "STATES_SCS") {
//       setStateOptions(
//         store?.stateItems?.data?.states?.map((s) => ({
//           value: s.state,
//           label: s.state_full_name,
//         })) || []
//       );
//     }

//     if (store?.actionFlag === "CITIES_SCS") {
//       setCityOptions(
//         store?.cityItems?.data?.cities?.map((c) => ({
//           value: c.city,
//           label: c.city,
//         })) || []
//       );
//     }
//   }, [store?.actionFlag]);

//   useEffect(() => {
//     if (selectedHospitalRole && selectedCity && selectedState) {
//       dispatch(
//         getHospitalData({
//           state: selectedState ? selectedState?.value : "",
//           city: selectedCity ? selectedCity?.value : "",
//           role: selectedHospitalRole?.value
//             ? selectedHospitalRole?.value
//             : selectedHospitalRole,
//         })
//       );
//     }
//   }, [
//     dispatch,
//     selectedCity,
//     selectedHospitalRole,
//     selectedState,
//     store?.profileItem?.data,
//   ]);

//   useEffect(() => {
//     if (
//       comparisonStore?.actionFlag === "HOSPITAL_INFO_ITEMS_SCS" &&
//       comparisonStore?.hospitalItems
//     ) {
//       const newMapData = {
//         selectedRole: selectedHospitalRole?.value || "",
//         city: selectedCity?.value || "",
//         state: selectedState?.value || "",
//         hospitalData: comparisonStore?.hospitalItems?.data?.hospitals,
//       };

//       setMapData(newMapData);
//     } else {
//       const storedData = localStorage.getItem("mapPayload");
//       if (storedData) {
//         try {
//           const parsedData = JSON.parse(storedData);
//           setMapData(parsedData);
//         } catch (error) {
//           console.error("Error parsing map data:", error);
//         }
//       }
//     }
//   }, [
//     comparisonStore?.actionFlag,
//     comparisonStore?.hospitalItems,
//     selectedCity?.value,
//     selectedHospitalRole?.value,
//     selectedState?.value,
//   ]);

//   useEffect(() => {
//     if (stateOptions?.length && mapData?.state) {
//       const foundState = stateOptions.find(
//         (item) => item.value === mapData.state
//       );
//       setSelectedState(foundState || null);
//     }

//     if (cityOptions?.length > 0 && mapData?.city) {
//       const foundCity = cityOptions.find((item) => item.value === mapData.city);
//       setSelectedCity(foundCity || null);
//     }
//     if (filterRoleOptions?.length > 0 && mapData?.selectedRole) {
//       const foundRole = filterRoleOptions?.find(
//         (item) => item?.value === mapData?.selectedRole?.value
//       );
//       setSelectedHospitalRole(foundRole);
//     }
//   }, [mapData, stateOptions, cityOptions]);

//   return (
//     <div className="dashboard-content">
//       <NoIndexSEO title={seoConfig.fullmap.title} />
//       <div className="app-page-title">
//         <div className="page-title-heading">
//           <h3 className="page-title">Full Map</h3>
//         </div>
//       </div>

//       <Card className="pb-0">
//         <CardBody>
//           <Row>
//             {/* State Filter */}
//             <Col lg={4} md={4} sm={4} className="filter-box">
//               <Form.Group className="form-group">
//                 <Form.Label className="col-label">State</Form.Label>
//                 <Select
//                   aria-label="Select State"
//                   value={selectedState}
//                   onChange={(selectedOption) => {
//                     setSelectedState(selectedOption || "");
//                     setSelectedCity("");
//                   }}
//                   menuPosition="fixed"
//                   styles={{
//                     menu: (base) => ({
//                       ...base,
//                       borderRadius: "15px",
//                       marginTop: "8px",
//                       backgroundColor: "#fff",
//                       padding: "6px",
//                       zIndex: 1000,
//                     }),
//                     menuPortal: (base) => ({
//                       ...base,
//                       zIndex: 9999,
//                     }),
//                     option: (base, state) => ({
//                       ...base,
//                       borderRadius: "8px",
//                       padding: "10px",
//                       backgroundColor: state.isFocused ? "#F3F9FC" : "#fff",
//                       color: "#091F28",
//                       cursor: "pointer",
//                       "&:active": {
//                         backgroundColor: "#F3F9FC",
//                       },
//                     }),
//                   }}
//                   options={stateOptions}
//                   isClearable
//                   placeholder="All States"
//                   className="react-select-container"
//                   classNamePrefix="react-select"
//                 />
//               </Form.Group>
//             </Col>

//             {/* City Filter */}
//             <Col lg={4} md={4} sm={4} className="filter-box">
//               <Form.Group className="form-group">
//                 <Form.Label className="col-label">City</Form.Label>
//                 <Select
//                   aria-label="Select City"
//                   value={selectedCity}
//                   onChange={(selectedOption) =>
//                     setSelectedCity(selectedOption || "")
//                   }
//                   menuPosition="fixed"
//                   styles={{
//                     menu: (base) => ({
//                       ...base,
//                       borderRadius: "15px",
//                       marginTop: "8px",
//                       backgroundColor: "#fff",
//                       padding: "6px",
//                       zIndex: 1000,
//                     }),
//                     menuPortal: (base) => ({
//                       ...base,
//                       zIndex: 9999,
//                     }),
//                     option: (base, state) => ({
//                       ...base,
//                       borderRadius: "8px",
//                       padding: "10px",
//                       backgroundColor: state.isFocused ? "#F3F9FC" : "#fff",
//                       color: "#091F28",
//                       cursor: "pointer",
//                       "&:active": {
//                         backgroundColor: "#F3F9FC",
//                       },
//                     }),
//                   }}
//                   options={cityOptions}
//                   isClearable
//                   placeholder="All Cities"
//                   className="react-select-container"
//                   classNamePrefix="react-select"
//                 />
//               </Form.Group>
//             </Col>

//             {/* Role Filter */}
//             <Col lg={4} md={4} sm={4} className="dash-filter">
//               <Form.Group className="form-group">
//                 <Form.Label className="col-label">
//                   Filter by Nursing Role
//                 </Form.Label>
//                 <Select
//                   aria-label="Filter by role"
//                   value={selectedHospitalRole}
//                   onChange={(selectedOption) =>
//                     setSelectedHospitalRole(selectedOption || "")
//                   }
//                   menuPosition="fixed"
//                   styles={{
//                     menu: (base) => ({
//                       ...base,
//                       borderRadius: "15px",
//                       marginTop: "8px",
//                       backgroundColor: "#fff",
//                       padding: "6px",
//                       zIndex: 1000,
//                     }),
//                     menuPortal: (base) => ({
//                       ...base,
//                       zIndex: 9999,
//                     }),
//                     option: (base, state) => ({
//                       ...base,
//                       borderRadius: "8px",
//                       padding: "10px",
//                       backgroundColor: state.isFocused ? "#F3F9FC" : "#fff",
//                       color: "#091F28",
//                       cursor: "pointer",
//                       "&:active": {
//                         backgroundColor: "#F3F9FC",
//                       },
//                     }),
//                   }}
//                   options={filterRoleOptions}
//                   isClearable
//                   placeholder="Select Role"
//                   className="react-select-container"
//                   classNamePrefix="react-select"
//                 />
//               </Form.Group>
//             </Col>
//           </Row>
//         </CardBody>
//       </Card>

//       {/* Map Section */}
//       <div className="salary-costs-hospitals">
//         <div className="contentwrap">
//           <Card>
//             <CardBody>
//               <Card.Header>
//                 {/* View Switch Buttons */}
//                 <div className="innertitle-subtitle with-hospitals">
//                   <div className="right-content w-100 justify-content-end">
//                     <div className="group-btn">
//                       <button
//                         type="button"
//                         className={view === "map" ? "active" : ""}
//                         aria-label="Map view"
//                         onClick={() => setView("map")}
//                       >
//                         <img src={MapViewIcon} alt="Map view" />
//                       </button>
//                       <button
//                         type="button"
//                         className={view === "list" ? "active" : ""}
//                         aria-label="List view"
//                         onClick={() => setView("list")}
//                       >
//                         <img src={ListViewIcon} alt="List view" />
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </Card.Header>
//               <div
//                 className="dash-map-img"
//                 style={{ height: "100%", overflow: "unset" }}
//               >
//                 {view === "map" ? (
//                   <div style={{ width: "100%", height: "100vh" }}>
//                     <Map
//                       selectedRole={mapData.selectedRole}
//                       city={mapData.city}
//                       state={mapData.state}
//                       hospitalData={mapData.hospitalData}
//                     />
//                   </div>
//                 ) : (
//                   <div className="hospital-listing">
//                     {/* <HospitalListing store={comparisonStore} />
//                      */}
//                     <HospitalListing store={comparisonStore} from="full-map" />
//                   </div>
//                 )}
//               </div>
//             </CardBody>
//           </Card>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FullMapPage;

import React, { useEffect, useRef, useState } from "react";
import Map from "./Map";
import { Row, Col, Card, Form, CardBody } from "react-bootstrap";
import Select from "react-select";
import {
  getAllStates,
  getAllCities,
  getRoles,
} from "../../redux/slices/profileSlice";

import MapViewIcon from "../../assets/images/map-view-icon.png";
import ListViewIcon from "../../assets/images/list-view.png";
import { useDispatch, useSelector } from "react-redux";
import { getHospitalData } from "../../redux/slices/comparison.Slice";
import HospitalListing from "../hospitalListing";
import NoIndexSEO from "../SEO/NoIndexSEO";

import { components } from "react-select";
import { seoConfig } from "../../utils/seoConfig";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { allowedNames, allowedRolesForFree } from "../../constants";
import ActionModal from "../../pages/comparison/ActionModal";
import CityDetailLimitModal from "../../pages/restriction-modals/CityDetailLimitModal";
import ComparisonModal from "../../pages/restriction-modals/ComparisonModal";
import {
  activityEnd,
  activityStart,
  trackActivity,
} from "../../redux/slices/trackActivitySlice";
import { useScreenTime } from "../../hooks/useScreen";
import usePageTracking from "../../hooks/usePageTracking";

const FullMapPage = () => {
  const [mapData, setMapData] = useState({
    selectedRole: "",
    city: "",
    state: "",
    hospitalData: [],
  });
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedHospitalRole, setSelectedHospitalRole] = useState(null);
  const profilePrefilledRef = useRef({ state: false, city: false, role: false });
  const [upgradeSource, setUpgradeSource] = useState("");

  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [filterRoleOptions, setFilterRoleOptions] = useState([]);

  const [subAlertModalVisible, setSubAlertModalVisible] = useState(false);
  const [subAlertCompModalVisible, setSubAlertCompModalVisible] = useState(
    false,
  );
  const [subText, setSubText] = useState({
    header: "",
    desc: "",
    massage1: "",
    pluspricem: "",
    pluspricey: "",
    desc2: "",
    promassage: "",
    propricem: "",
    propricey: "",
  });
  const [view, setView] = useState("map");

  const store = useSelector((state) => state.profile);
  const profile =
    store?.profileItem?.data || JSON.parse(localStorage.getItem("user"));
  const comparisonStore = useSelector((state) => state.comparison);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authStore = useSelector((state) => state.auth);
  const location = useLocation();
  const isFullMapPage = location.pathname.split("/").filter(Boolean);
  const [isRestrictedData, setIsRestrictedData] = useState({
    is_comparisan: true,
    comparisanMessage: "",
    header: "",
    messageBody1: "",
    messageBody2: "",
  });

  // ------------------------------------------------------------------
  // 1. Load initial data
  // ------------------------------------------------------------------
  useEffect(() => {
    dispatch(getAllStates());
    dispatch(getRoles());
  }, [dispatch]);

  // ------------------------------------------------------------------
  // 2. Populate options when redux finishes
  // ------------------------------------------------------------------
  useEffect(() => {
    if (store?.actionFlag === "ROLE_SCS") {
      // const data = store?.roleItems?.data?.describe_roles?.map((s) => ({
      //   value: s.id,
      //   label: s.name,
      // }));
      // const planName = store?.profileItem?.data?.plan?.name;
      const planName = authStore?.user?.plan?.name
        ? authStore?.user?.plan?.name
        : store?.profileItem?.data?.plan?.name;
      const data = store?.roleItems?.data?.describe_roles?.map((s) => {
        const roleName = s.name;
        let isDisabled = false;
        let requiredPlan = "";

        if (planName === "Free") {
          if (!allowedRolesForFree.includes(roleName)) {
            isDisabled = true;
            requiredPlan = "Pro";
          }
        }

        return {
          value: s.id,
          label: roleName,
          isDisabled,
          requiredPlan,
        };
      });
      setFilterRoleOptions(data);
    }

    if (store?.actionFlag === "STATES_SCS") {
      setStateOptions(
        store?.stateItems?.data?.states?.map((s) => ({
          value: s.state,
          label: s.state_full_name,
        })) || [],
      );
    }

    if (store?.actionFlag === "CITIES_SCS") {
      setCityOptions(
        store?.cityItems?.data?.cities?.map((c) => ({
          value: c.city,
          label: c.city,
        })) || [],
      );
    }
  }, [
    store?.actionFlag,
    store?.cityItems?.data?.cities,
    store?.roleItems?.data?.describe_roles,
    store?.stateItems?.data?.states,
    store?.profileItem,
    authStore?.user?.plan?.name,
  ]);

  useEffect(() => {
    if (comparisonStore?.comparisonItem) {
      setIsRestrictedData({
        is_comparisan: comparisonStore?.comparisonItem.is_comparisan,
        comparisanMessage: comparisonStore?.comparisonItem.comparisanMessage,
        header: comparisonStore?.comparisonItem.header,
        messageBody1: comparisonStore?.comparisonItem.messageBody1,
        messageBody2: comparisonStore?.comparisonItem.messageBody2,
      });
    }
  }, [comparisonStore?.comparisonItem]);

  // ------------------------------------------------------------------
  // 3. Load cities when state changes
  // ------------------------------------------------------------------
  useEffect(() => {
    if (selectedState?.value) {
      dispatch(
        getAllCities({
          search_state: selectedState.value,
        }),
      );
    }
  }, [dispatch, selectedState]);

  // ------------------------------------------------------------------
  // 3.5 Pre-fill selectors from navigation state (e.g. when a user clicks
  //     "View on map" from a city-detail page). location.state.fromCityDetail
  //     carries the city / state / role to auto-select. Each effect waits
  //     for its options to load (state options arrive first; cities load
  //     only after a state is set; roles load independently).
  // ------------------------------------------------------------------
  const fromCityDetail = location.state?.fromCityDetail;
  const norm = (s) =>
    String(s ?? "")
      .trim()
      .toLowerCase();

  useEffect(() => {
    if (!fromCityDetail?.state) return;
    if (selectedState?.value === fromCityDetail.state) return;
    if (!stateOptions?.length) return;
    const target = norm(fromCityDetail.state);
    const match = stateOptions.find(
      (s) => norm(s.value) === target || norm(s.label) === target,
    );
    if (match) setSelectedState(match);
  }, [stateOptions, fromCityDetail?.state]);

  useEffect(() => {
    if (!fromCityDetail?.city) return;
    if (selectedCity?.value === fromCityDetail.city) return;
    if (!cityOptions?.length) return;
    const target = norm(fromCityDetail.city);
    const match = cityOptions.find(
      (c) => norm(c.value) === target || norm(c.label) === target,
    );
    if (match) setSelectedCity(match);
  }, [cityOptions, fromCityDetail?.city]);

  useEffect(() => {
    if (!fromCityDetail?.role) return;
    if (
      selectedHospitalRole?.label &&
      norm(selectedHospitalRole.label).startsWith(norm(fromCityDetail.role))
    )
      return;
    if (!filterRoleOptions?.length) return;
    const target = norm(fromCityDetail.role);
    const stripSuffix = (label) =>
      norm(String(label).replace(/\s*\([^)]*\)\s*$/, ""));
    const match = filterRoleOptions.find(
      (r) => stripSuffix(r.label) === target,
    );
    if (match && !match.isDisabled) setSelectedHospitalRole(match);
  }, [filterRoleOptions, fromCityDetail?.role]);

  // ------------------------------------------------------------------
  // 3.6 Pre-fill state, city, and role from profile store
  //     (only when no navigation data is present, and only once each)
  // ------------------------------------------------------------------
  useEffect(() => {
    if (fromCityDetail) return;
    if (profilePrefilledRef.current.state) return;
    if (!stateOptions?.length) return;
    const liveStateCode = store?.profileItem?.data?.living_state_info?.state;
    if (!liveStateCode) return;
    const match = stateOptions.find((s) => s.value === liveStateCode);
    if (match) {
      profilePrefilledRef.current.state = true;
      setSelectedState(match);
    }
  }, [stateOptions, store?.profileItem?.data, fromCityDetail]);

  useEffect(() => {
    if (fromCityDetail) return;
    if (profilePrefilledRef.current.city) return;
    if (!cityOptions?.length) return;
    const liveCity = store?.profileItem?.data?.city;
    if (!liveCity) return;
    const target = liveCity.toLowerCase().trim();
    const match = cityOptions.find(
      (c) => c.value.toLowerCase().trim() === target,
    );
    if (match) {
      profilePrefilledRef.current.city = true;
      setSelectedCity(match);
    }
  }, [cityOptions, store?.profileItem?.data, fromCityDetail]);

  useEffect(() => {
    if (fromCityDetail) return;
    if (profilePrefilledRef.current.role) return;
    if (!filterRoleOptions?.length) return;
    const nursingRoleId = store?.profileItem?.data?.nursing_role?.id;
    if (!nursingRoleId) return;
    const match = filterRoleOptions.find((r) => r.value === nursingRoleId);
    if (match && !match.isDisabled) {
      profilePrefilledRef.current.role = true;
      setSelectedHospitalRole(match);
    }
  }, [filterRoleOptions, store?.profileItem?.data, fromCityDetail]);

  // ------------------------------------------------------------------
  // 4. Fetch hospitals when all three filters are set
  // ------------------------------------------------------------------
  useEffect(() => {
    if (selectedHospitalRole && selectedState && selectedCity) {
      dispatch(
        getHospitalData({
          state: selectedState.value || "",
          city: selectedCity.value || "",
          role: selectedHospitalRole.value || "",
        }),
      );
    }
  }, [dispatch, selectedCity, selectedHospitalRole, selectedState]);

  useEffect(() => {
    // Skip the state-only fetch while profile pre-fill is still in progress
    // (state was set but city hasn't been pre-filled yet — the full fetch
    // will happen via the other effect once all three values are ready).
    if (profilePrefilledRef.current.state && !profilePrefilledRef.current.city) return;
    if (selectedState) {
      dispatch(
        getHospitalData({
          state: selectedState?.value || "",
          city: selectedCity ? selectedCity?.value : "",
          role: selectedHospitalRole?.value || "",
        }),
      );
    }
  }, [dispatch, selectedState]);

  // ------------------------------------------------------------------
  // 5. Update mapData when hospital data arrives (or fallback to localStorage)
  // ------------------------------------------------------------------
  useEffect(() => {
    if (
      comparisonStore?.actionFlag === "HOSPITAL_INFO_ITEMS_SCS" &&
      comparisonStore?.hospitalItems?.data?.hospitals
    ) {
      const newMapData = {
        selectedRole: selectedHospitalRole?.value || "",
        city: selectedCity?.value || "",
        state: selectedState?.value || "",
        hospitalData: comparisonStore.hospitalItems.data.hospitals,
      };

      setMapData(newMapData);
    }
    // // If no fresh data from API, try to restore from localStorage once on mount
    // else if (comparisonStore?.actionFlag !== "HOSPITAL_INFO_ITEMS_SCS") {
    //   const stored = localStorage.getItem("mapPayload");
    //   //
    //   if (stored) {
    //     try {
    //       const parsed = JSON.parse(stored);
    //       setMapData(parsed);
    //     } catch (e) {
    //       console.error("Failed to parse mapPayload from localStorage", e);
    //     }
    //   }
    // }
  }, [
    comparisonStore?.actionFlag,
    comparisonStore?.hospitalItems,
    selectedCity,
    selectedHospitalRole,
    selectedState,
  ]);

  useEffect(() => {
    if (!selectedState && !selectedCity && !selectedHospitalRole) return;

    const payload = {
      selectedRole: selectedHospitalRole?.value || "",
      city: selectedCity?.value || "",
      state: selectedState?.value || "",
      hospitalData: comparisonStore?.hospitalItems?.data?.hospitals || [],
    };

    localStorage.setItem("mapPayload", JSON.stringify(payload));
  }, [
    selectedState,
    selectedCity,
    selectedHospitalRole,
    comparisonStore?.hospitalItems?.data?.hospitals,
  ]);

  // useEffect(() => {
  //   if (
  //     mapData === null &&
  //     comparisonStore?.actionFlag !== "HOSPITAL_INFO_ITEMS_SCS"
  //   ) {
  //     const stored = localStorage.getItem("mapPayload");
  //
  //     if (stored) {
  //       try {
  //         const parsed = JSON.parse(stored);
  //         setMapData(parsed);
  //       } catch (e) {
  //         console.error("Failed to parse mapPayload from localStorage", e);
  //       }
  //     }
  //   }
  // }, [comparisonStore?.actionFlag, mapData]);

  useEffect(() => {
    // If the user arrived via "View on map" from a city detail page, the
    // nav state should drive selection — skip the localStorage restore so
    // it doesn't fight the fromCityDetail pre-fill effects above.
    if (fromCityDetail) return;
    const stored = localStorage.getItem("mapPayload");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setMapData(parsed);
      } catch (e) {
        console.error("Failed to parse mapPayload from localStorage", e);
      }
    }
  }, [fromCityDetail]);

  // ------------------------------------------------------------------
  // 6. *** THIS IS THE FIXED PART ***
  //     Restore State / City / Role from localStorage once options are ready
  // ------------------------------------------------------------------
  // 6. Restore State / City / Role from localStorage once options are ready
  // 6. Restore State / City / Role from localStorage (FIXED)
  useEffect(() => {
    // Skip restoration when navigating from a city detail — fromCityDetail
    // pre-fill takes priority over saved session state.
    if (fromCityDetail) return;
    // If no saved data, skip
    if (!mapData.state && !mapData.city && !mapData.selectedRole) return;

    // Restore State (skip if profile pre-fill already handled it)
    if (stateOptions.length > 0 && mapData.state && !selectedState && !profilePrefilledRef.current.state) {
      const foundState = stateOptions.find(
        (opt) => opt.value === mapData.state,
      );
      if (foundState) setSelectedState(foundState);
    }

    // // Restore City (skip if profile pre-fill already handled it)
    if (
      cityOptions.length > 0 &&
      mapData.city &&
      !selectedCity &&
      !profilePrefilledRef.current.city &&
      selectedState?.value === mapData?.state
    ) {
      const foundCity = cityOptions.find((opt) => opt.value === mapData.city);
      if (foundCity) setSelectedCity(foundCity);
    }

    // Restore Role — NOW HANDLES BOTH CASES: object or raw ID (skip if profile pre-fill already handled it)
    if (
      filterRoleOptions.length > 0 &&
      mapData.selectedRole &&
      !selectedHospitalRole &&
      !profilePrefilledRef.current.role
    ) {
      let roleId;

      // Case 1: Full object saved (your current case)
      if (
        typeof mapData.selectedRole === "object" &&
        mapData.selectedRole.value != null
      ) {
        roleId = mapData.selectedRole.value;
      }
      // Case 2: Only ID saved (string/number) — backward compatibility
      else {
        roleId = mapData.selectedRole;
      }

      const foundRole = filterRoleOptions.find((opt) => opt.value == roleId);

      if (foundRole) {
        setSelectedHospitalRole(foundRole);
      } else {
        console.warn("Role ID not found in options:", roleId);
      }
    }
  }, [
    mapData,
    stateOptions,
    cityOptions,
    filterRoleOptions,
    selectedState,
    selectedCity,
    selectedHospitalRole,
  ]);

  useEffect(() => {
    const html = document.documentElement;

    if (isFullMapPage) {
      html.classList.add("overflowhidden");
    } else {
      html.classList.remove("overflowhidden");
    }

    return () => {
      html.classList.remove("overflowhidden"); // cleanup on page exit
    };
  }, [isFullMapPage]);

  const { start, stop } = useScreenTime();

  useEffect(() => {
    start();

    const handleBeforeUnload = () => {
      const result = stop();

      if (!result) return;

      dispatch(
        trackActivity({
          page_name: "VIEW_FULL_MAP",
          duration: result.durationMinutes,
        }),
      );
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);

      const result = stop();
      if (!result) return;

      dispatch(
        trackActivity({
          page_name: "VIEW_FULL_MAP",
          duration: result.durationMinutes,
        }),
      );
    };
  }, []);
  useEffect(() => {
    const payload = {
      page_name: "VIEW_FULL_MAP",
      platform: "web",
    };

    dispatch(activityStart(payload));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(
        activityEnd({
          page_name: "VIEW_FULL_MAP",
        }),
      );
    };
  }, [dispatch]);

  usePageTracking("VIEW_FULL_MAP");

  // const CustomRoleOption = (props) => {
  //   const { isDisabled } = props;

  //   return (
  //     <div
  //       onClick={(e) => {
  //         if (isDisabled) {
  //           e.stopPropagation(); // Prevents selection
  //           setSubText({
  //             header: "Subscription Required!",
  //             desc: "Plus or Pro plan is required",
  //           });
  //           setSubAlertModalVisible(true);
  //         }
  //         // For enabled options: do nothing → react-select handles selection normally
  //       }}
  //       style={{
  //         width: "100%",
  //         cursor: isDisabled ? "pointer" : "default",
  //       }}
  //     >
  //       <components.Option {...props} />
  //     </div>
  //   );
  // };

  // ------------------------------------------------------------------
  // Render
  // ------------------------------------------------------------------
  const CustomRoleOption = (props) => {
    const { isDisabled, data } = props;
    const { requiredPlan } = data;

    return (
      <div
        onClick={(e) => {
          if (isDisabled) {
            e.stopPropagation();
            const source = "nursing_role_limit";
            setUpgradeSource(source);
            if (requiredPlan === "Pro") {
              setSubText({
                header: "Subscription Required!",
                desc: "",
                massage1: "",
                massage2: "",
                desc2: "You need a Pro plan to unlock this role",
                promassage:
                  "Pro users see all 9 nursing roles, including NP, CRNA, and Midwife",
                // promassage: "Upgrade to Pro for full role visibility",
                propricem: "$2.99/month",
                propricey: "$29.99/year",
                plan: "Pro",
                lockedItemName: data.label,
              });
            }

            setSubAlertCompModalVisible(true);
          }
        }}
        style={{
          width: "100%",
          cursor: isDisabled ? "pointer" : "default",
        }}
      >
        <components.Option {...props}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px" }}>
            <span style={{ color: isDisabled ? "var(--mmp-text-secondary)" : "var(--mmp-text-primary)" }}>{data.label}</span>
            {data.requiredPlan && (
              <span style={{
                flexShrink: 0,
                fontSize: "9px",
                fontWeight: 800,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                color: "var(--mmp-accent)",
                background: "var(--mmp-accent-bg)",
                border: "1px solid var(--mmp-accent-border)",
                borderRadius: "999px",
                padding: "1px 6px",
              }}>{data.requiredPlan}</span>
            )}
          </div>
        </components.Option>
      </div>
    );
  };
  return (
    <div className="dashboard-content full-map">
      <NoIndexSEO title={seoConfig.fullmap.title} />
      <div className="app-page-title">
        <div className="page-title-heading">
          <h3 className="page-title">
            <div className="page-title-heading d-flex align-items-center">
              <FiArrowLeft
                size={40}
                className="icon cursor-pointer"
                onClick={() => navigate("/dashboard")}
              />
              <h3 className="page-title">
                {selectedState && selectedCity
                  ? `Hospitals in ${selectedState?.label}, ${selectedCity?.label}`
                  : `Hospitals in ${profile?.living_state ||
                      ""}, ${profile?.city || ""}`}
              </h3>
            </div>
          </h3>
        </div>
      </div>

      <Card className="pb-0 fliterbox-content">
        <CardBody>
          <Row>
            {/* State Filter */}
            {/*  md={4} sm={4} */}
            <Col md={4} className="filter-box col-4">
              <Form.Group className="form-group">
                <Form.Label className="col-label">State</Form.Label>
                <Select
                  aria-label="Select State"
                  value={selectedState}
                  onChange={(val) => {
                    setSelectedState(val);
                    setSelectedCity(null);
                  }}
                  options={stateOptions}
                  isClearable
                  placeholder="All States"
                  menuPosition="fixed"
                  styles={{
                    menu: (base) => ({
                      ...base,
                      borderRadius: "15px",
                      marginTop: "8px",
                      backgroundColor: "var(--mmp-surface)",
                      padding: "6px",
                      zIndex: 1000,
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "var(--mmp-text-primary)",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "var(--mmp-text-secondary)",
                    }),
                    option: (base, state) => ({
                      ...base,
                      borderRadius: "8px",
                      padding: "10px",
                      backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                      color: "var(--mmp-text-primary)",
                      cursor: "pointer",
                      "&:active": {
                        backgroundColor: "var(--mmp-hover-bg)",
                      },
                    }),
                  }}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </Col>

            {/* City Filter */}
            {/*  md={4} sm={4} */}
            <Col md={4} className="filter-box col-4">
              <Form.Group className="form-group">
                <Form.Label className="col-label">City</Form.Label>
                <Select
                  aria-label="Select City"
                  value={selectedCity}
                  onChange={setSelectedCity}
                  options={cityOptions}
                  isClearable
                  placeholder="All Cities"
                  menuPosition="fixed"
                  styles={{
                    menu: (base) => ({
                      ...base,
                      borderRadius: "15px",
                      marginTop: "8px",
                      backgroundColor: "var(--mmp-surface)",
                      padding: "6px",
                      zIndex: 1000,
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "var(--mmp-text-primary)",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "var(--mmp-text-secondary)",
                    }),
                    option: (base, state) => ({
                      ...base,
                      borderRadius: "8px",
                      padding: "10px",
                      backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                      color: "var(--mmp-text-primary)",
                      cursor: "pointer",
                      "&:active": {
                        backgroundColor: "var(--mmp-hover-bg)",
                      },
                    }),
                  }}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </Col>

            <Col md={4} className="d-flex d-md-none col-4 mobile">
              <div className="innertitle-subtitle with-hospitals">
                <div className="right-content w-100 justify-content-end">
                  <div className="group-btn">
                    <button
                      type="button"
                      className={view === "map" ? "active" : ""}
                      aria-label="Map view"
                      onClick={() => setView("map")}
                    >
                      <img src={MapViewIcon} alt="Map view" />
                    </button>
                    <button
                      type="button"
                      className={view === "list" ? "active" : ""}
                      aria-label="List view"
                      onClick={() => setView("list")}
                    >
                      <img src={ListViewIcon} alt="List view" />
                    </button>
                  </div>
                </div>
              </div>
            </Col>

            {/* Role Filter */}
            {/*  md={4} sm={4} */}
            <Col md={4} className="dash-filter col-12">
              <Form.Group className="form-group">
                <Form.Label className="col-label">
                  Filter by Nursing Role
                </Form.Label>
                <Select
                  aria-label="Filter by role"
                  value={selectedHospitalRole}
                  onChange={setSelectedHospitalRole}
                  options={filterRoleOptions}
                  components={{ Option: CustomRoleOption }}
                  isClearable
                  placeholder="Select Role"
                  menuPosition="fixed"
                  styles={{
                    menu: (base) => ({
                      ...base,
                      borderRadius: "15px",
                      marginTop: "8px",
                      backgroundColor: "var(--mmp-surface)",
                      padding: "6px",
                      zIndex: 1000,
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "var(--mmp-text-primary)",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "var(--mmp-text-secondary)",
                    }),
                    option: (base, state) => ({
                      ...base,
                      borderRadius: "8px",
                      padding: "6px 10px",
                      lineHeight: 1.3,
                      backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                      color: state.isDisabled ? "var(--mmp-text-secondary)" : "var(--mmp-text-primary)",
                      fontSize: "13px",
                      fontWeight: 500,
                      opacity: 1,
                      cursor: state.isDisabled ? "pointer" : "default",
                      "&:active": {
                        backgroundColor: "var(--mmp-hover-bg)",
                      },
                    }),
                  }}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* Map / List View */}
      <div className="salary-costs-hospitals map">
        <div className="contentwrap">
          <Card>
            <CardBody>
              <div className="innertitle-subtitle with-hospitals d-none d-md-block">
                <div className="right-content w-100 justify-content-end">
                  <div className="group-btn">
                    <button
                      type="button"
                      className={view === "map" ? "active" : ""}
                      aria-label="Map view"
                      onClick={() => setView("map")}
                    >
                      <img src={MapViewIcon} alt="Map view" />
                    </button>
                    <button
                      type="button"
                      className={view === "list" ? "active" : ""}
                      aria-label="List view"
                      onClick={() => setView("list")}
                    >
                      <img src={ListViewIcon} alt="List view" />
                    </button>
                  </div>
                </div>
              </div>

              <div
                className="dash-map-img"
                style={{ height: "100%", overflow: "unset" }}
              >
                {view === "map" ? (
                  <div
                    className="map"
                    style={{ width: "100%", height: "100vh" }}
                  >
                    <Map
                      selectedRole={mapData.selectedRole}
                      city={mapData.city}
                      state={mapData.state}
                      hospitalData={mapData.hospitalData}
                      restrictedData={isRestrictedData}
                    />
                  </div>
                ) : (
                  <div className="hospital-listing">
                    <HospitalListing
                      store={comparisonStore}
                      restrictedData={isRestrictedData}
                      from="full-map"
                    />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      <ComparisonModal
        title={subText?.header}
        description={subText.desc}
        massage1={subText.massage1}
        pluspricem={subText.pluspricem}
        pluspricey={subText.pluspricey}
        prodesc={subText.desc2}
        promassage={subText.promassage}
        propricem={subText.propricem}
        propricey={subText.propricey}
        plan={subText.plan}
        lockedItemName={subText.lockedItemName}
        isVisible={subAlertCompModalVisible}
        eventSource={upgradeSource}
        onClose={() => {
          setSubAlertCompModalVisible(false);
        }}
        onPressYes={() => {
          // Navigate to subscription page or handle upgrade
          navigate("/profile/subscription");
          setSubAlertCompModalVisible(false);
        }}
        yesText="Upgrade Now"
        noText="Cancel"
        // extraData={isRestrictedData}
        extraMetaInfo={true}
      />

      <CityDetailLimitModal
        isVisible={subAlertModalVisible}
        eventSource={upgradeSource}
        onClose={() => setSubAlertModalVisible(false)}
      />
    </div>
  );
};

export default FullMapPage;
